import Vue from 'vue'
import Router from 'vue-router'
import AuthClientInfo from './auth-client-info'
import LoadFloorplan from './LoadFloorplan'
// import authTransaction from './auth-transaction'

Vue.use(Router)

function load(component) {
  return () => import(`@/components/${component}.vue`)
}

export const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || (to.hash ? { selector: to.hash } : { x: 0, y: 0 })
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: load('project/ListProjects')
    },
    {
      path: '/projects',
      name: 'ListProjects',
      component: load('project/ListProjects')
    },
    {
      path: '/projects/:fUrl',
      name: 'ShowProject',
      component: load('project/ShowProject')
    },
    {
      path: '/projects/:fUrl/:floorplanId',
      name: 'ViewFloorplan',
      component: load('floorplan/ViewFloorplan'),
      props: true,
      beforeEnter: LoadFloorplan
    },
    {
      path: '/profile/:id',
      name: 'Profile',
      component: load('common/Profile'),
      props: true,
      beforeEnter: AuthClientInfo
    },
    {
      path: '/profile/:userId/print/:transactionId',
      name: 'ViewCart',
      component: load('cart/ViewCart'),
      props: true
    },

    {
      path: '/signout',
      name: 'Signout',
      component: load('auth/Signout')
    },
    {
      path: '/404',
      component: load('common/404')
    },
    {
      path: '/503',
      component: load('common/503')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js